const BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

const decodeBase64Url = (input) => {
	const clean = input
		.replace(/[=]+$/, '')
		.replace(/\+/g, '-')
		.replace(/\//g, '_');
	let out = '';
	for (let i = 0; i < clean.length; i += 4) {
		const chunk = clean.slice(i, i + 4);
		let n = 0;
		for (let j = 0; j < 4; j++) {
			const value = BASE64URL.indexOf(chunk[j] ?? 'A');
			if (value < 0) {
				return '';
			}
			n = n * 64 + value;
		}
		const bytes = [Math.floor(n / 65536), Math.floor(n / 256) % 256, n % 256];
		out += String.fromCharCode(...bytes.slice(0, chunk.length - 1));
	}
	return out;
};

export const decodeJwtPayload = (token) => {
	if (typeof token !== 'string') {
		return null;
	}
	const payload = token.split('.')[1];
	if (!payload) {
		return null;
	}
	try {
		const decoded = JSON.parse(decodeBase64Url(payload));
		return decoded && typeof decoded === 'object' ? decoded : null;
	} catch {
		return null;
	}
};

export const normalizeBusinessCodes = (raw) => {
	if (!Array.isArray(raw) || !raw.every((code) => typeof code === 'string')) {
		return null;
	}
	const codes = [...new Set(raw.filter((code) => code !== ''))].sort();
	return codes.length > 0 ? codes : null;
};

export const sameBusinessCodes = (a, b) =>
	a === b || (!!a && !!b && a.length === b.length && a.every((code, i) => code === b[i]));

export const businessCodesOfCustomToken = (fToken) => {
	const claims = decodeJwtPayload(fToken)?.claims;
	return normalizeBusinessCodes(claims && typeof claims === 'object' ? claims.businessCodes : null);
};
